import React, { useState } from "react";

const EMOJI_CATEGORIES = {
  'Smileys': ['😀','😂','🥰','😍','😊','😉','😎','🤗','🤔','😅','😢','😭','😡','🥳','😴','🤮','👍','👎','👏','🙏','💪','❤️','🔥','⭐','✅','❌','💯','🎉'],
  'Objects': ['📞','📱','💻','📧','📋','📁','💰','💳','🏥','💊','🩺','⏰','📅','🔔','📌','✏️','🔑','📊','📈','🗂️']
};

export const EmojiPicker = ({ onSelect, onClose }) => {
  const [activeCategory, setActiveCategory] = useState('Smileys');
  
  return (
    <div className="absolute bottom-full mb-2 left-0 bg-navy-200 border border-slate-700 rounded-xl shadow-2xl w-72 z-50" data-testid="emoji-picker">
      <div className="flex border-b border-slate-700">
        {Object.keys(EMOJI_CATEGORIES).map(cat => (
          <button key={cat} onClick={() => setActiveCategory(cat)}
            className={`flex-1 py-2 text-xs font-medium transition-colors ${activeCategory === cat ? 'text-gold border-b-2 border-gold' : 'text-slate-400 hover:text-white'}`}>
            {cat}
          </button>
        ))}
      </div>
      <div className="p-2 grid grid-cols-7 gap-1 max-h-40 overflow-y-auto">
        {EMOJI_CATEGORIES[activeCategory].map(emoji => (
          <button key={emoji} onClick={() => { onSelect(emoji); onClose(); }}
            className="w-8 h-8 flex items-center justify-center text-lg hover:bg-slate-700/50 rounded transition-colors">
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};
